jQuery( document ).ready(function() {
  
  jQuery( 'input[name="cod"]' ).val( getUrlParameter('c') );
  
  	var script = document.createElement("script");  // create a script DOM node
    script.src = 'https://upgradeable.tw/intranet3/survey/'+ getUrlParameter('c') +'/script.js';  // set its src to the provided URL

    document.body.appendChild(script);  // add it to the end of the head section of the page (could change 'head' to 'bo
  
  
  console.log( '$_GET[c] = ' + getUrlParameter('c') );
  
  
  
});


var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = decodeURIComponent(window.location.search.substring(1)),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : sParameterName[1];
        }
    }
};